<div class="claim-form" *ngIf="!isClaimAction">
  <p class="claim-form__empty">Aucune action</p>
  <button type="button" class="claim-form__outlined" (click)="back.emit()">Retour</button>
</div>

<div class="claim-form" *ngIf="isClaimAction && success">
  <div class="claim-success">
    <mat-icon>check_circle</mat-icon>
    <h2>{{ successMessage }}</h2>
    <dl class="claim-success__list" *ngIf="successControls.length">
      <div *ngFor="let control of successControls; let i = index" class="claim-success__row">
        <div>
          <dt>{{ sentence(control.label) }}</dt>
          <dd>{{ displayValue(control) }}</dd>
        </div>
        <button
          *ngIf="isLastSuccessItem(i)"
          type="button"
          class="claim-success__pdf"
          (click)="downloadReceipt()"
          [disabled]="downloadingReceipt"
          aria-label="Télécharger l’attestation">
          <mat-icon>picture_as_pdf</mat-icon>
        </button>
      </div>
    </dl>
    <button type="button" class="claim-form__primary" (click)="finish()">Ok</button>
  </div>
</div>

<div class="claim-form" *ngIf="isClaimAction && !success">
  <article class="claim-card">
    <span class="claim-card__icon"><mat-icon>policy</mat-icon></span>
    <div>
      <strong>{{ sentence(concern?.label || '-') }}</strong>
      <small *ngIf="concern?.second">{{ sentence(concern?.second) }}</small>
      <hr />
      <strong class="claim-card__cover">{{ coverageTitle }}</strong>
      <small>Du {{ coverageFrom }} au {{ coverageTo }}</small>
    </div>
  </article>

  <article class="claim-card">
    <span class="claim-card__step">Étape {{ currentPage + 1 }}/{{ steps.length || 1 }}</span>
    <span class="claim-card__progress"><span [style.width.%]="progress * 100"></span></span>
    <strong>{{ stepTitle }}</strong>
    <small>Complétez les informations ci-dessous</small>
  </article>

  <ng-container *ngIf="isPhotoStep; else formStep">
    <p class="claim-photos__title">Ajoutez les photos requises</p>
    <p class="claim-photos__hint">{{ photoCount }} photo{{ photoCount > 1 ? 's' : '' }} à fournir</p>
    <div class="claim-photos">
      <label class="claim-photos__slot" *ngFor="let preview of photoPreviews; let i = index">
        <img *ngIf="preview" [src]="preview" alt="" />
        <span *ngIf="!preview">Photo {{ i + 1 }}</span>
        <input type="file" accept="image/*" (change)="onPhotoSelected(i, $event)" />
      </label>
    </div>
  </ng-container>

  <ng-template #formStep>
    <div class="claim-field" *ngFor="let control of currentControls">
      <ng-container [ngSwitch]="controlType(control)">
        <label class="claim-toggle" *ngSwitchCase="'toggle_switch'">
          <span>{{ sentence(control.label) }}</span>
          <input
            type="checkbox"
            [checked]="locationEnabled"
            (change)="onToggleLocation(control.name || '', inputChecked($event))" />
        </label>

        <label *ngSwitchCase="'list'">
          <span>{{ sentence(control.label) }}</span>
          <select [formControl]="fieldControl(control.name)">
            <option value="">Sélectionner</option>
            <option *ngFor="let option of listOptions(control)" [value]="listOptionValue(option)">
              {{ listOptionLabel(option) }}
            </option>
          </select>
        </label>

        <label *ngSwitchCase="'date'">
          <span>{{ sentence(control.label) }}</span>
          <input
            type="date"
            [value]="dateInputValue(control.name || '')"
            [readOnly]="!!control.readOnly"
            [disabled]="control.enabled === false"
            (change)="onDateInput(control.name || '', $event)" />
        </label>

        <label *ngSwitchDefault>
          <span>{{ sentence(control.label) }}</span>
          <textarea
            *ngIf="(control.maxLine || 1) > 1"
            [formControl]="fieldControl(control.name)"
            [attr.rows]="control.maxLine || 3"
            [attr.readonly]="control.readOnly ? true : null"></textarea>
          <input
            *ngIf="(control.maxLine || 1) <= 1"
            type="text"
            [formControl]="fieldControl(control.name)"
            [attr.readonly]="control.readOnly ? true : null"
            [attr.inputmode]="control.format === 'currency' || controlType(control) === 'numeric' ? 'decimal' : null"
            (input)="control.format === 'currency' ? onCurrencyInput(control.name || '', $event) : null" />
          <small *ngIf="control.format === 'currency'">{{ currency }}</small>
        </label>
      </ng-container>
      <p class="claim-field__error" *ngIf="fieldControl(control.name)?.touched && fieldControl(control.name)?.invalid">
        {{ control.validationMessage || 'Champ invalide' }}
      </p>
    </div>
  </ng-template>

  <div class="claim-form__nav">
    <button type="button" class="claim-form__outlined" (click)="previousStep()" [disabled]="isFirst">Retour</button>
    <button type="button" class="claim-form__primary" (click)="nextStep()">
      {{ isLast ? 'Terminer' : 'Continuer' }}
    </button>
  </div>

  <div class="claim-recap" *ngIf="showRecap" (click)="previousStep()">
    <div class="claim-recap__sheet" (click)="$event.stopPropagation()">
      <span class="claim-recap__handle"></span>
      <header class="claim-recap__head">
        <button type="button" class="claim-form__icon-btn" (click)="previousStep()" aria-label="Fermer">
          <mat-icon>close</mat-icon>
        </button>
        <h2>Récapitulatif</h2>
        <span class="claim-recap__spacer"></span>
      </header>
      <p class="claim-form__empty" *ngIf="!recapControls.length">Aucune information à afficher</p>
      <article class="claim-recap__item" *ngFor="let control of recapControls">
        <span>{{ sentence(control.label || control.name) }}</span>
        <strong>{{ displayValue(control) }}</strong>
      </article>
      <button type="button" class="claim-form__primary" (click)="submit()" [disabled]="submitting">
        {{ submitting ? 'Envoi…' : 'Envoyer' }}
      </button>
    </div>
  </div>

  <div class="claim-overlay" *ngIf="submitting">
    <span class="claim-overlay__dots" aria-hidden="true"></span>
  </div>
</div>
